import { STANDARD_PAGE_FETCH_REQUESTED } from './actionTypes';

export const fetchStandardPage = (category, slug) => ({
  type: STANDARD_PAGE_FETCH_REQUESTED,
  payload: { category, slug },
});
